import { CheckCircle, Typography, Button } from "@fanka/ui-admin";
import { CheckInCompleteProps } from "@on-site/components/pages/checkIn/ui/CheckInComplete/type";
import { useTimeout } from "@on-site/hooks/useTimeout";

export const CheckInComplete = ({ onStartOver, isLoading = false }: CheckInCompleteProps) => {
  useTimeout(onStartOver, 1000 * 2);

  return (
    <div className="mx-auto flex h-full w-full max-w-[424px] flex-col items-center justify-center gap-y-6">
      <CheckCircle className="stroke-grayScale-500 h-12 w-12" />
      <Typography.Heading type="h1">チェックインが完了しました</Typography.Heading>
      <Typography.UiText size="lg">スタッフがお呼びするまで、待合室にてしばらくお待ちください。</Typography.UiText>
      <Button size="lg" block onClick={onStartOver} isLoading={isLoading}>
        最初の画面へ
      </Button>
    </div>
  );
};
